import CartBindings from './CartBindings';
import Calendar from './../../common/modules/calendar/Calendar';
import Validation from '../../common/assets/js/validation';
import Helpers from '../../common/modules/helpers/helpers';

export default new class Cart {

    constructor() {
        new CartBindings();
        this.calendarDetailsTag = '.js-product-calendar';
        this.addToCartBtn = '.add-to-cart';
        this.productCalendar = '.js-product-calendar';
        this.mobileCartIcon = '._js-mobile-cart';
        this.hintNoActiveArenda = '.hint-no-active-arenda';

        this.hintNoActiveArendaActive = null;

        this.scrollTopAnimationSpeed = 300;
        this.calendarOffsetTopMargin = 20;

        this.addToCartHandler();
        this.orderCreateHandler();
        this.closeHintNoActiveArenda();
    }

    closeHintNoActiveArenda() {
        $(document).on('click', () => {
            if (this.hintNoActiveArendaActive) {
                this.hintNoActiveArendaActive.hide();
                this.hintNoActiveArendaActive = null;
            }
        });
    }


    addToCartHandler() {
        $('.product-offers').on('click', this.addToCartBtn, (e) => {

            e.stopPropagation();
            e.preventDefault();

            if (!$(e.target).hasClass('add-to-cart')) {
                return;
            }

            if ($(e.target).hasClass('dontActiveArenda')) {
                if (this.hintNoActiveArendaActive) {
                    this.hintNoActiveArendaActive.hide();
                }
                this.hintNoActiveArendaActive = $(this.hintNoActiveArenda, $(e.target));
                this.hintNoActiveArendaActive.show();
                return false;
            }

            //user had selected dates
            let $target = $(e.target),
                maxValue = parseInt($target.closest('.product-offers__description_quantity').find('._js-prod-count').attr('data-max-value')),
                $productRow = $target.closest('.product-offers__owner'),
                $itemsAvailableText = $productRow.find('.product-offers__availabe'),
                $rentBtn = $productRow.find('.add-to-cart'),
                currentValue = parseInt($productRow.find('.text-field-prod_quantity').val()),
                $mobileCartCount = $('.js-mobile-cart-count');

            /*show/hide tooltip if selected currentValue more than maxValue*/
            if (currentValue > maxValue ) {
                $itemsAvailableText.addClass('_error');
                $rentBtn.addClass('_disabled');
                return false;
            } else {
                $itemsAvailableText.removeClass('_error');
                $rentBtn.removeClass('_disabled');
            }

            if (!Validation.validateInput($target.closest('.product-offers__description').find('._js-prod-count')[ 0 ], true)) {
                return false;
            }

            //check is user selected dates, if not - open calendar, show overlay
            if (!window.isDateSelected) {
                this.scrollCalendarIntoView();
                $(this.calendarDetailsTag).prop('open', true);
                Calendar.toggleCalendarOverlay(true);
                $(e.currentTarget).addClass('_choose-for-rent');
                return;
            }
            let dateStart = $('.oc-filter-shopaholic._calendar-data ._start-date input').val(),
                period = $('.oc-filter-shopaholic._calendar-data ._period input').val();

            $mobileCartCount.text(parseInt($mobileCartCount.text()) + 1);

            $.request('Cart::onAdd', {
                data: {
                    cart: [{
                        'offer_id': $($target).parents('.product-offers__owner').attr('data-offer-id'),
                        'quantity': currentValue,
                        'date_start': dateStart,
                        'period': period,
                    }],
                    'date_start': dateStart,
                    'period': period,
                },
                update: {
                    'offer_list': 'table.product-offers',
                    'product_pagination_button': '.oc-shopaholic-pagination',
                    'product_offer_count': '.product-description__purchase .btn',
                    'jade-cart-button': '.cart-button-wrapper'
                },
                complete: () => {
                    //add link to the cart icon for mobile
                    if (Helpers.isMobile() && parseInt($('.js-mobile-cart-count').text()) > 0) {
                        $(this.mobileCartIcon).attr('href', window.location.origin + '/cart' );
                    }
                }
            });
        });
    }

    /**
     * Scrolls page to paroduct calendar
     */
    scrollCalendarIntoView () {
        let $productCalendar = $(this.productCalendar);

        if (!this.checkVisible($productCalendar[0])) {
            $('html, body').animate({scrollTop: `${$productCalendar.offset().top - this.calendarOffsetTopMargin}px`}, this.scrollTopAnimationSpeed);
        }
    }

    /**
     * Checks is element visible on the screen
     *
     * @param element - DOM element
     * @returns {boolean} - is element visible on the screen
     */
    checkVisible(element) {
        let rect = element.getBoundingClientRect(),
            viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);

        return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
    }

    orderCreateHandler() {

        $('.cart-contact').on('submit', (e) => {
            e.stopPropagation();
            e.preventDefault();

            $('.order-error-tooltip').hide();

            $('.cart-contact').request('OrderCreate::onCreate', {
                loading: '.js-preloaderOverlay',
                complete: (response) => {
                    let obResult = response.responseJSON,
                        $cartSubmitError = $('.cart-contact__submit-error');

                    $cartSubmitError.hide();

                    if(!obResult || !obResult.result) {
                        if (obResult.data.offer_id) {
                            var $cartItem = $('.cart-item[data-offer-id="' + obResult.data.offer_id +'"]'),
                                $orderErrorTooltip = $cartItem.find('.order-error-tooltip');

                            $orderErrorTooltip.empty();
                            $orderErrorTooltip.text(obResult.data.message);
                            $orderErrorTooltip.show();

                            $('html, body').animate({
                                scrollTop: $orderErrorTooltip.offset()
                            }, 'slow');
                        } else {
                            $cartSubmitError.show().text(obResult.data.message);
                        }
                        return;
                    }

                    location.href = '/order/complete/' + obResult.data;
                }
            });
        });
    }
};


// WEBPACK FOOTER //
// ./src/pages/cart/Cart.js